import { render, staticRenderFns } from "./orderWarning.vue?vue&type=template&id=4f2ae9a9&scoped=true"
import script from "./orderWarning.vue?vue&type=script&lang=js"
export * from "./orderWarning.vue?vue&type=script&lang=js"
import style0 from "./orderWarning.vue?vue&type=style&index=0&id=4f2ae9a9&lang=scss&scoped=true"
import style1 from "./orderWarning.vue?vue&type=style&index=1&id=4f2ae9a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ae9a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2ae9a9')) {
      api.createRecord('4f2ae9a9', component.options)
    } else {
      api.reload('4f2ae9a9', component.options)
    }
    module.hot.accept("./orderWarning.vue?vue&type=template&id=4f2ae9a9&scoped=true", function () {
      api.rerender('4f2ae9a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderWarning.vue"
export default component.exports